export var InternalAuditStatus;
(function (InternalAuditStatus) {
    InternalAuditStatus["Complete"] = "complete";
    InternalAuditStatus["InProgress"] = "inprogress";
    InternalAuditStatus["NotStarted"] = "notstarted";
})(InternalAuditStatus || (InternalAuditStatus = {}));
//# sourceMappingURL=internal-audit-status.js.map